export default function Footer() {
  return (
    <footer className="bg-[#0d1b2a] text-white relative overflow-hidden">
      {/* Decorative World Map Background */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 200 L200 180 L300 190 L400 170 L500 185 L600 175 L700 190 L800 180 L900 195 L1000 185 L1100 200" stroke="currentColor" strokeWidth="2"/>
        </svg>
      </div>

      {/* Main Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Left Brand Section */}
          <div className="lg:col-span-2">
            <div className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-6">
              行政書士ARISEリーガルオフィス<span className="text-[#ff6b35]">.</span>
            </div>

            <div className="text-lg sm:text-2xl font-serif leading-relaxed">
              施工体制台帳・安全書類作成の<br />
              プロフェッショナルパートナー
            </div>
          </div>

          {/* Navigation Columns */}
          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4">サービス</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="#services" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">施工体制台帳作成</a></li>
              <li><a href="#services" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">安全書類作成</a></li>
              <li><a href="#services" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">電子化サポート</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4">対応システム</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="#services" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">グリーンサイト</a></li>
              <li><a href="#services" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">ワークサイト</a></li>
              <li><a href="#services" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">サイトアシスト</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4">お問い合わせ</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li><a href="#contact-form" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">無料相談</a></li>
              <li><a href="#contact-form" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">見積依頼</a></li>
              <li><a href="#faq" className="text-xs sm:text-sm text-gray-300 hover:text-[#ff6b35] transition-colors cursor-pointer">よくある質問</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-gray-700 flex flex-col md:flex-row items-center justify-between gap-4 sm:gap-6">
          <div className="text-xs text-gray-400 text-center md:text-left">
            © 2025 行政書士ARISEリーガルオフィス. All rights reserved.
          </div>

          <div className="flex items-center gap-3 sm:gap-6">
            <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-gray-600 rounded-lg flex items-center justify-center text-white hover:border-[#ff6b35] hover:text-[#ff6b35] transition-all cursor-pointer">
              <i className="ri-twitter-x-line text-sm sm:text-base"></i>
            </a>
            <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-gray-600 rounded-lg flex items-center justify-center text-white hover:border-[#ff6b35] hover:text-[#ff6b35] transition-all cursor-pointer">
              <i className="ri-facebook-fill text-sm sm:text-base"></i>
            </a>
            <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-gray-600 rounded-lg flex items-center justify-center text-white hover:border-[#ff6b35] hover:text-[#ff6b35] transition-all cursor-pointer">
              <i className="ri-instagram-line text-sm sm:text-base"></i>
            </a>
            <a href="#" className="w-9 h-9 sm:w-10 sm:h-10 border-2 border-gray-600 rounded-lg flex items-center justify-center text-white hover:border-[#ff6b35] hover:text-[#ff6b35] transition-all cursor-pointer">
              <i className="ri-linkedin-fill text-sm sm:text-base"></i>
            </a>
          </div>

          <div className="text-xs text-gray-400 flex flex-wrap items-center justify-center gap-2 sm:gap-4">
            <a href="#" className="hover:text-[#ff6b35] transition-colors cursor-pointer whitespace-nowrap">プライバシーポリシー</a>
            <span className="hidden sm:inline">|</span>
            <a href="#" className="hover:text-[#ff6b35] transition-colors cursor-pointer whitespace-nowrap">利用規約</a>
            <span className="hidden sm:inline">|</span>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#ff6b35] transition-colors cursor-pointer whitespace-nowrap">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
